// src/layouts/AdminLayout.jsx
import React from "react";
import { Link, useNavigate ,Outlet } from "react-router-dom";

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();

  // const handleLogout = () => {
  //   localStorage.removeItem("token");
  //   navigate("/admin/login");
  // };

  return (
    <div className="flex min-h-screen">
      {/* Sidebar
      <aside className="w-64 bg-gray-900 text-white p-4">
        <h2 className="text-xl font-bold mb-6">Admin Panel</h2>
        <nav className="flex flex-col gap-4">
          <Link to="/admin/dashboard" className="hover:text-blue-300">Products</Link>
          <Link to="/admin/categories" className="hover:text-blue-300">Categories</Link>
          <button onClick={handleLogout} className="mt-auto text-red-400 hover:text-red-600">
            Logout
          </button>
        </nav>
      </aside> */}

      {/* Main Content */}
      <main className="flex-1 bg-gray-50 p-6">{children}</main>
    <Outlet/>
    </div>
  );
};

export default AdminLayout;
